export const ERROR = 'Ocurrió un error.';
export const SUCCESS = 'Acción realizada con éxito.';

export const USUARIO_NO_PERMISO = 'No cuenta con los permisos necesarios.'

